import { render, staticRenderFns } from "./adminNav.vue?vue&type=template&id=0bacd3f1&scoped=true&"
import script from "./adminNav.vue?vue&type=script&lang=js&"
export * from "./adminNav.vue?vue&type=script&lang=js&"
import style0 from "./adminNav.vue?vue&type=style&index=0&id=0bacd3f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bacd3f1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
